import _ from 'lodash'

/**
 * Returns the appropriate precision when outputting a dataset value. Accounts
 * for the possibility that a context-specific precision (like widget config)
 * may override the field's precision.
 *
 * @param {Object} field - the dataset field that the value is coming from
 *
 * @param {String|Number} [configuredPrecision] - the precision configured for
 * this context
 *
 * @return {Number} the precision to use. May be null, which indicates that the
 * default precision from Application Administration should be used.
 */
function datasetValuePrecision ({ field, configuredPrecision }) {
	let precision = parseInt(configuredPrecision)
	if (_.isFinite(precision)) {
		return precision
	} else {
		return _.get(field, 'precision')
	}
}

export default datasetValuePrecision

datasetValuePrecision.__filename__ = 'datasets/dataset-value-precision.js'
